/**
 * EmptyState Atom
 *
 * Estado vazio para listas
 */
import React from 'react'
import { Inbox } from 'lucide-react'
import Button from './Button'

export default function EmptyState({
	icon: Icon = Inbox,
	title = 'Nenhum item encontrado',
	description,
	action,
	actionLabel,
	className = '',
}) {
	return (
		<div className={`flex flex-col items-center justify-center py-12 px-4 text-center ${className}`}>
			<div className="w-16 h-16 rounded-full bg-base-400 flex items-center justify-center mb-4">
				<Icon className="w-8 h-8 text-text-body" />
			</div>
			<h3 className="text-lg font-medium text-text mb-1">
				{title}
			</h3>
			{description && (
				<p className="text-text-body max-w-sm mb-4">
					{description}
				</p>
			)}
			{action && actionLabel && (
				<Button onClick={action}>
					{actionLabel}
				</Button>
			)}
		</div>
	)
}
